<template>
  <div class="purchase-detail-page">
    <fm-title title-text="采购明细" :titleMenus="titleMenus" @clickTitleMenu="clickTitleMenu">
      <div class="title-sort">
        <div class="fm-tabs fm-tabs-norm">
          <div class="fm-tabs-nav">
            <div @click="dealStatus = item.key" class="fm-tabs-nav-item" :class="{'fm-tabs-nav-active': item.key === dealStatus}" v-for="item in dealSwitch" :key="item.key">
              {{item.label}}
            </div>
          </div>
        </div>
      </div>
    </fm-title>
    <deal-block
      class="p-d-s"
      v-if="dealStatus === 'wait_deal' && !batchDeal && waitDealDataList.length > 0"
      :dataList="waitDealDataList"
      :statusMap="statusMap"
      :orgList="orgList"
      :batchData="batchData"
      @dataUpdate="dataUpdate"
      :budgetDetailList="budgetDetailList">
    </deal-block>
    <batch-deal-block
      class="p-d-s"
      v-else-if="dealStatus === 'wait_deal' && batchDeal && waitDealDataList.length > 0"
      :dataList="waitDealDataList"
      :batchData="batchData"
      @dataUpdate="dataUpdate">
    </batch-deal-block>
    <list-info
      class="p-d-s"
      v-else-if="dealStatus !== 'wait_deal' && (dealStatus === 'dealed' ? dealedDataList : dataList).length > 0"
      :dataList="dealStatus === 'dealed' ? dealedDataList : dataList"
      :config="config"
      :statusMap="statusMap"
      @dataUpdate="dataUpdate">
    </list-info>
    <div class="p-d-s-n" v-else>
      <div>暂无数据</div>
    </div>
    <detail-form @dataUpdate="dataUpdate" :orgList="orgList" :budgetDetailList="budgetDetailList" ref="dForm" :data="chooseData"></detail-form>
  </div>
</template>

<script>
import detailForm from './components/details/form'
import dealBlock from './components/details/dealBlock'
import batchDealBlock from './components/details/batchDealBlock'
import listInfo from './components/details/list'

import {
  purchaseBatchRequest,
  budgetDetailRequest,
  purchaseBatchDetailsRequest,
  statusManageRequest
} from '../../api'

export default {
  components: {
    detailForm,
    dealBlock,
    batchDealBlock,
    listInfo
  },
  data () {
    return {
      config: [],
      dealSwitch: [{key: 'wait_deal', label: '待处理'}, {key: 'dealed', label: '已处理'}, {key: 'all', label: '全部'}],
      dealStatus: 'wait_deal',
      batchDeal: false,
      chooseData: null,
      dataList: [],
      batchId: null,
      batchData: null,
      pageType: null,
      canAdd: false,
      statusMap: {},
      budgetDetailList: []
    }
  },
  created () {
    this.$store.dispatch('loadOrgList')
    this.$store.dispatch('loadUserList')
    this.loadConfig()
  },
  activated () {
    this.init()
  },
  computed: {
    waitDealDataList () {
      return this.dataList.filter(v => v.actions && v.actions.filter(v1 => v1.key !== 'back_status_switch').length > 0)
    },
    dealedDataList () {
      return this.dataList.filter(v => !v.actions || v.actions.filter(v1 => v1.key !== 'back_status_switch').length === 0)
    },
    titleMenus () {
      return this.canAdd ? [{key: 'batchDeal', label: '批量操作'}, {key: 'add', label: '添加采购申请'}] : [{key: 'batchDeal', label: '批量操作'}]
    },
    orgList () {
      let allData = this.$store.getters.orgList
      let batchOrgIds = this.batchData && this.batchData.orgIds ? this.batchData.orgIds.split(',').map(v => Number(v)) : []
      let myOrgIds = this.$store.getters.currentOrgId ? [this.$store.getters.currentOrgId] : []
      return allData.filter(v => batchOrgIds.includes(v.key) && myOrgIds.includes(v.key))
    }
  },
  methods: {
    async loadConfig () {
      let datas = await statusManageRequest.switchConfig({
        statusGroupKey: 'purchaseBatchDetail'
      })
      if (!datas) {
        this.config = []
        return
      }
      let data = []
      while (datas) {
        let dataItem = {}
        Object.keys(datas).forEach(key => !['nextHostStatusSwitchFlow', 'conditionList'].includes(key) ? dataItem[key] = datas[key] : null)
        data.push(dataItem)
        datas = datas.nextHostStatusSwitchFlow && datas.nextHostStatusSwitchFlow.length > 0 ? datas.nextHostStatusSwitchFlow[0] : null
      }
      this.config = data

      let c = await statusManageRequest.config({
        statusGroupKey: 'purchaseBatchDetail'
      })
      c.statusList.forEach(v => {
        this.statusMap[v.statusKey] = v.label
      })
    },
    async dataUpdate () {
      await this.loadData()
    },
    async init () {
      this.dealStatus = 'wait_deal'
      this.batchDeal = false
      this.chooseData = null
      this.dataList = []
      this.batchId = this.$router.history.current.query.id
      this.pageType = this.$router.history.current.query.type
      await this.loadBatch()
      this.loadData()
      this.loadBudgetDetailList()
    },
    async loadBatch () {
      if (!this.batchId || !this.pageType) {
        return
      }
      let datas = await purchaseBatchRequest.get({
        id: this.batchId
      })
      if (datas.length !== 1) {
        this.$notify({
          title: '系统提示',
          message: '采购批次不存在',
          type: 'warning'
        })
        return
      }
      this.batchData = datas[0]
      this.canAdd = (this.batchData.actions || []).find(v => v.key === 'add_detail') && true
    },
    async loadData () {
      if (!this.batchData || !this.batchId || !this.pageType) {
        return
      }
      let datas = []
      if (this.pageType !== 'index') {
        datas = await purchaseBatchDetailsRequest.getByAuth({
          purchaseBatchId: this.batchId,
          statusActionRecord: 1
        })
      } else {
        datas = await purchaseBatchDetailsRequest.get({
          purchaseBatchId: this.batchId,
          statusActionRecord: 1
        })
      }
      datas.forEach(v => {
        v.fileIds = (v.fileIds || '').split(',').filter(v => v).map(v => Number(v))
      })
      this.dataList = datas
    },
    async loadBudgetDetailList () {
      if (!this.batchData || !this.batchData.year) {
        return
      }
      let datas = await budgetDetailRequest.get({
        status: 'final_pass',
        year: this.batchData.year,
        needPurchaseBatchDetail: 1
      })
      this.budgetDetailList = datas
    },
    clickTitleMenu (key) {
      if (key === 'add') {
        if (this.orgList.length === 0) {
          this.$notify({
            title: '系统提示',
            message: '无可填报科室',
            type: 'warning'
          })
          return
        }
        this.chooseData = {
          purchaseBatchId: this.batchId
        }
        this.$refs.dForm.modal = true
      } else if (key === 'batchDeal') {
        if (this.dealStatus !== 'wait_deal') {
          this.dealStatus = 'wait_deal'
          this.batchDeal = true
        } else {
          this.batchDeal = !this.batchDeal
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.purchase-detail-page {
  background: #fff;
  width: calc(100% - 20px);
  height: calc(100% - 20px);
  margin: 10px;
  .title-sort {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .p-d-c {
    width: calc(100% - 40px);
    height: calc(100% - 88px);
  }
  .p-d-s {
    width: 100%;
    height: calc(100% - 48px);
  }
  .p-d-s-n {
    width: 100%;
    height: calc(100% - 48px);
    font-size: 20px;
    color: #515a6e;
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      padding: 20px;
    }
  }
  .left {
    height: calc(100% - 20px);
    overflow-y: auto;
    width: 300px;
    border-right: 1px solid #e8eaec;;
    padding-right: 20px;
  }
  .right {
    height: calc(100% - 20px);
    flex: 1;
    overflow-y: auto;
    border-top: 1px solid #e8eaec;;
    border-right: 1px solid #e8eaec;;
    border-bottom: 1px solid #e8eaec;;
    .right-btns {
      padding:10px 20px;
      display: flex;
      justify-content: space-around;
    }
  }
  .sign-item {
    margin-bottom: 10px;
  }
}
</style>